// extracted by mini-css-extract-plugin
export default {"form":"profile-password-form_form__hmX4n"};